export default __webpack_public_path__ + "static/media/alianza.c713e0e2.png";